import { render, staticRenderFns } from "./search-organization.modal.vue?vue&type=template&id=d9ff788c&"
import script from "./search-organization.modal.vue?vue&type=script&lang=ts&"
export * from "./search-organization.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports